export default {
  title: 'Obtenha a melhor experiência na nossa app móvel',
  description: 'Poupe tempo, acumule recompensas, receba notificações de mais ofertas e muito mais',
  buttons: {
    download: 'Abrir a app {{name}}',
  },
};
